<script>
  import { ShopboxGridBuilder } from '@shopboxai/shopbox-grid-builder';
  import { userToken, currentClient, currentClientWebsite, currentUser } from '../stores';
  $: cid = $currentClientWebsite ? $currentClientWebsite : $currentClient;
</script>

<!--  -->
<ShopboxGridBuilder user={JSON.stringify($userToken)} currentUser={$currentUser} currentClient={$currentUser.fullClientId} client={cid} />
